export const DocIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.37972 7.67059C7.64334 7.6706 7.04639 8.26755 7.04639 9.00393L7.04639 9.33726L13.6737 9.33726C14.4101 9.33726 15.007 8.74031 15.007 8.00393V7.67059L8.37972 7.67059ZM9.69333 12.6667C10.4297 12.6667 11.0267 12.0697 11.0267 11.3334L11.0267 11L8.36069 11C7.6243 11 7.02734 11.597 7.02734 12.3334V12.6667L9.69333 12.6667Z"
				fill="#B182BC"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.33317 4.16667C5.33317 3.89052 5.55703 3.66667 5.83317 3.66667H7.29139V4.66035C7.2914 5.48878 7.96297 6.16035 8.79139 6.16035H13.2591C14.0875 6.16035 14.7591 5.48878 14.7591 4.66035V3.66667H16.6665V17.8333C16.6665 18.1094 16.4426 18.3333 16.1665 18.3333H5.33317V4.16667ZM13.9258 2H18.3332V17.8333C18.3332 19.0299 17.3631 19.9999 16.1665 19.9999H3.6665V4.16667C3.6665 2.97005 4.63655 2 5.83317 2H8.12473H13.9258ZM8.95806 3.66667H13.0924V4.49369L8.95806 4.49369V3.66667Z"
				fill="black"
			/>
		</svg>
	)
}
